import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ProjectRoutes from './ProjectRoutes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ProjectRoutes />
  </React.StrictMode>
);

